import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const humidity_IN: typeof valueTypeRenderers.humidity_IN = {
  label: () => unitConverter.humidityInCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.humidityInCanopy().title(),
      render: (n) => unitConverter.humidityInCanopy(n).valueAsString(),
    }),
}
